<template>
  <v-text-field
    v-model="xPartes"
    type="number"
    label="Dividir a área de concessão em X partes"
    :min="min"
    prepend-icon="mdi-numeric-1-box-multiple-outline"
  />
</template>

<script>
  export default {
    name: 'FormQuebrarAratBdgdConfig',
    props: {
      algoritmoConfig: {
        type: Object
      }
    },
    data() {
      return {
        xPartes: 2,
        min: 2
      };
    },
    mounted() {
      this.algoritmoConfigAtualizado();
      if (this.algoritmoConfig) this.fillInputs();
    },
    methods: {
      algoritmoConfigAtualizado() {
        this.$emit('algoritmoConfigAtualizado', {
          xPartes: Number(this.xPartes),
          min: this.min
        });
      },
      fillInputs() {
        this.xPartes = this.algoritmoConfig.xPartes;
        this.min = this.algoritmoConfig.min;
      }
    },
    watch: {
      xPartes() {
        this.algoritmoConfigAtualizado();
      }
    }
  };
</script>
